import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import React from 'react';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import 'react/jsx-runtime';
import '@mui/joy';
import '@cognite/cogs-icons';

var Heading = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$level = _a.level,
    level = _a$level === undefined ? 1 : _a$level,
    as = _a.as,
    muted = _a.muted,
    children = _a.children,
    className = _a.className,
    inverted = _a.inverted,
    textColor = _a.textColor,
    rest = __rest(_a, ["level", "as", "muted", "children", "className", "inverted", "textColor"]);
  return /*#__PURE__*/React.createElement(as || "h" + level, Object.assign(Object.assign({}, rest), {
    className: classNames.apply(undefined, ['cogs-v10', 'cogs-typography', "cogs-heading-" + level, muted && 'muted', textColor && "cogs-typography--" + textColor].concat(getThemeClassNames(inverted), [className])),
    ref: ref
  }), children);
});
var Overline = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$size = _a.size,
    size = _a$size === undefined ? 'medium' : _a$size,
    as = _a.as,
    muted = _a.muted,
    children = _a.children,
    className = _a.className,
    inverted = _a.inverted,
    textColor = _a.textColor,
    rest = __rest(_a, ["size", "as", "muted", "children", "className", "inverted", "textColor"]);
  var extendedClassName = classNames.apply(undefined, ['cogs-v10', 'cogs-typography', "cogs-overline-" + size, muted && 'muted', textColor && "cogs-typography--" + textColor].concat(getThemeClassNames(inverted), [className]));
  return /*#__PURE__*/React.createElement(as || "p", Object.assign(Object.assign({}, rest), {
    className: extendedClassName,
    ref: ref
  }), children);
});
var Body = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$size2 = _a.size,
    size = _a$size2 === undefined ? 'medium' : _a$size2,
    as = _a.as,
    children = _a.children,
    strong = _a.strong,
    muted = _a.muted,
    className = _a.className,
    inverted = _a.inverted,
    style = _a.style,
    noOfLines = _a.noOfLines,
    textColor = _a.textColor,
    rest = __rest(_a, ["size", "as", "children", "strong", "muted", "className", "inverted", "style", "noOfLines", "textColor"]);
  var extendedClassName = classNames.apply(undefined, ['cogs-v10', 'cogs-typography', "cogs-body-" + size, noOfLines && 'cogs-body--ellipsis', strong && 'strong', muted && 'muted', textColor && "cogs-typography--" + textColor].concat(getThemeClassNames(inverted), [className]));
  var extendedStyle = Object.assign(Object.assign({}, style), {
    WebkitLineClamp: noOfLines || 'unset'
  });
  return /*#__PURE__*/React.createElement(as || "div", Object.assign(Object.assign({}, rest), {
    className: extendedClassName,
    ref: ref,
    style: extendedStyle
  }), children);
});
var Code = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$size3 = _a.size,
    size = _a$size3 === undefined ? 'medium' : _a$size3,
    noOfLines = _a.noOfLines,
    as = _a.as,
    children = _a.children,
    className = _a.className,
    style = _a.style,
    inverted = _a.inverted,
    textColor = _a.textColor,
    rest = __rest(_a, ["size", "noOfLines", "as", "children", "className", "style", "inverted", "textColor"]);
  var extendedClassName = classNames.apply(undefined, ['cogs-v10', 'cogs-typography', 'cogs-code', "cogs-code--size-" + size, noOfLines && 'cogs-code--ellipsis', textColor && "cogs-typography--" + textColor].concat(getThemeClassNames(inverted), [className]));
  var extendedStyle = Object.assign(Object.assign({}, style), {
    WebkitLineClamp: noOfLines || 'unset'
  });
  return /*#__PURE__*/React.createElement(as || "div", Object.assign(Object.assign({}, rest), {
    className: extendedClassName,
    ref: ref,
    style: extendedStyle
  }), children);
});

export { Body, Code, Heading, Overline };
